import { RecursivePartial } from "../../commonTypes/types";
import { QualifiedFeature, Qualifier } from "fe-common/graphql";
import { FREE_TEXT_FEATURE_ID, Relations } from "shared";
import { PatientFacingSuggestions } from "patient/src/types/patientConversationAliasing";

/*
 * A user can add a free text QF while using the autocomplete.
 * Such a QF is composed of: free-text| [relation:free-text-relation, value: free-text, freeText: some text]
 *
 * A QF might also contain multiple relations with free text for example:
 * feature: allergies| [relation:reaction, value: freeText, freeText: Swelling]*/

//TODO: the client should get the feature and relation full object from the server
export function buildFreeTextQF(
  text: string,
): RecursivePartial<QualifiedFeature> {
  return {
    feature: {
      id: FREE_TEXT_FEATURE_ID,
      name: text,
      shortname: text,
    },
    qualifiers: [
      {
        value: {
          id: FREE_TEXT_FEATURE_ID,
        },
        relation: {
          id: Relations.FREE_TEXT,
        },
        freeText: text,
      },
    ],
  };
}

export function convertFreeTextQF(
  freeTextQF: RecursivePartial<QualifiedFeature>,
  { featureId, relationId }: { featureId: string; relationId: string },
): RecursivePartial<QualifiedFeature> {
  const qualifier = {
    ...freeTextQF.qualifiers[0],
    relation: {
      id: relationId,
    },
  };

  return {
    ...freeTextQF,
    feature: {
      id: featureId,
    },
    mandatory: qualifier,
    qualifiers: [qualifier],
  };
}

export function getFreeTextFromQF(
  freeTextQF: RecursivePartial<QualifiedFeature>,
): string {
  const freeTextQ = freeTextQF?.qualifiers?.find?.(
    (q) => q.relation.id === Relations.FREE_TEXT,
  );
  // Make sure we clear all html, so users can't inject scripts
  return freeTextQ?.freeText?.replace?.(/<[^>]*>?/gm, "");
}

export function buildFreeTextQualifier(
  text: string,
  relationId: Relations,
): RecursivePartial<Qualifier> {
  return {
    relation: {
      id: relationId,
    },
    value: {
      id: FREE_TEXT_FEATURE_ID,
    },
    freeText: text,
  };
}

export function isFreeTextSuggestion(suggestion: PatientFacingSuggestions) {
  return (
    suggestion?.refinements?.[0]?.qualifiers?.[0].value?.id ===
    FREE_TEXT_FEATURE_ID
  );
}
